export const WidgetTypes = [
  {
    identifier: 'horoscope-form',
    label: 'Horoscope Form',
  },
  {
    identifier: 'tarot-form',
    label: 'Tarot Form',
  },
  {
    identifier: 'multistep-form',
    label: 'Multistep Form',
  },
  {
    identifier: 'multistep-birth-form',
    label: 'Multistep Birth Form',
  },
  {
    identifier: 'onepage-form',
    label: 'One Page Form',
  },
  {
    identifier: 'compact-form',
    label: 'Compact Form',
  },
  {
    identifier: 'xsell',
    label: 'Xsell',
  },
  {
    identifier: 'selection',
    label: 'Psychic Choice',
  },
  {
    identifier: 'confirmation',
    label: 'Confirmation',
  }
];

export const ContentLibraryTypes = [
  {
    identifier: 'html',
    label: 'HTML'
  },
  {
    identifier: 'image',
    label: 'Image'
  },
  {
    identifier: 'video',
    label: 'Video'
  }
];
